import React from 'react';
import ChatNotification from "./index";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";

export default function ChatNotificationWrapper(props) {

  const { data, isLoading } = useQuery({
    queryKey: ["IS_USER",],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate/certificate-user/is-user`)

      return data
    }
  })

  if (isLoading) {
    return null
  }

  if (!data?.isACertificateUser) {
    return null
  }

  return (
    <ChatNotification />
  )
}